// extracted by mini-css-extract-plugin
module.exports = {"picture":"Picture_picture__PL_Qs","picture-top":"Picture_picture-top__fDqlu","figcaption-top":"Picture_figcaption-top__sML7q"};